export const mdl21Urls = {
  inventoryDelivery: '/mdl21/inventory/delivery',
  inventoryPickup: '/inventory/pickup',
}
